import { render, staticRenderFns } from "./materialPurchase.vue?vue&type=template&id=0f47b3bd&scoped=true&"
import script from "./materialPurchase.vue?vue&type=script&lang=js&"
export * from "./materialPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f47b3bd",
  null
  
)

export default component.exports